import { styled } from '@mui/material/styles';
import Icon from 'core/svg-sprites/ui/Icon';

export const HeaderStyled = styled('header')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;

  ${({ theme }) => theme.breakpoints.up('mobile')} {
    margin-bottom: 16px;
  }
`;

export const CrossIconStyled = styled(Icon)`
  fill: ${({ theme }) => theme.palette.text.primary};
`;
